import { ref, provide, inject } from 'vue'

const DEPARTMENT_TYPES_KEY = Symbol('departmentTypes')

export function createDepartmentTypesProvider(api) {
  const departmentTypes = ref([])
  const loading = ref(false)
  const error = ref(null)

  const fetchDepartmentTypes = async (force = false) => {
    if (departmentTypes.value.length > 0 && !force) {
      return
    }

    loading.value = true
    error.value = null
    try {
      const response = await api.request('departament/types')
      departmentTypes.value = response.departamentTypes || response || []
    } catch (err) {
      error.value = err
      console.error('Error fetching department types:', err)
    } finally {
      loading.value = false
    }
  }

  const departmentTypesProvider = {
    departmentTypes,
    loading,
    error,
    fetchDepartmentTypes
  }

  provide(DEPARTMENT_TYPES_KEY, departmentTypesProvider)

  return departmentTypesProvider
}

export function useDepartmentTypes() {
  const departmentTypes = inject(DEPARTMENT_TYPES_KEY)
  if (!departmentTypes) {
    throw new Error('useDepartmentTypes must be used within a department types provider')
  }
  return departmentTypes
}
